import API from './api';

export const getDriverSafetyReport = (params = {}) => API.get('/reports/driver-safety', { params });
export const getDriverSafetyInsuranceReport = (params = {}) => API.get('/reports/driver-safety/insurance', { params });
export const getDriverSafetyEvents = (params = {}) => API.get('/reports/driver-safety/events', { params });
export const getDriverSafetyDrilldown = (driverId, params = {}) => (
  API.get(`/reports/driver-safety/drivers/${encodeURIComponent(driverId)}`, { params })
);
